// extracted by mini-css-extract-plugin
export default {"loadingButton":"styles_loadingButton__JBjtV","secondary":"styles_secondary__d-Jvz","st_v3":"styles_st_v3__xf-TH"};